import React, { useState } from 'react';
import { FaWhatsapp, FaTimes } from 'react-icons/fa';

const WhatsAppButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const phoneNumber = '919443832293'; // Updated phone number
  
  const quickMessages = [
    'Hi, I want to book a cab',
    'Need taxi for airport transfer',
    'Looking for sightseeing package',
  ];

  const sendMessage = (msg) => {
    const encodedMsg = encodeURIComponent(msg);
    window.open(`https://wa.me/${phoneNumber}?text=${encodedMsg}`, '_blank');
    setIsOpen(false);
  };

  return (
    <>
      {isOpen && (
        <div className="whatsapp-modal">
          <div className="modal-header">
            <h3>Quick WhatsApp Booking</h3>
            <button onClick={() => setIsOpen(false)} className="close-btn">
              <FaTimes />
            </button>
          </div>
          <div className="modal-body">
            {quickMessages.map((msg, index) => (
              <button
                key={index}
                className="quick-msg"
                onClick={() => sendMessage(msg)}
              >
                {msg}
              </button>
            ))}
          </div>
        </div>
      )}
      
      <button 
        className="whatsapp-button"
        onClick={() => setIsOpen(!isOpen)}
      >
        <FaWhatsapp size={24} />
      </button>
      
      <style jsx>{`
        .whatsapp-button {
          position: fixed;
          bottom: 30px;
          right: 30px;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
          color: white;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          z-index: 1000;
          box-shadow: 0 4px 20px rgba(37, 211, 102, 0.3);
          transition: transform 0.3s;
        }
        .whatsapp-button:hover {
          transform: scale(1.1);
        }
        .whatsapp-modal {
          position: fixed;
          bottom: 100px;
          right: 30px;
          width: 300px;
          background: white;
          border-radius: 10px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.2);
          z-index: 1001;
          overflow: hidden;
        }
        .modal-header {
          background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
          color: white;
          padding: 15px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .modal-header h3 {
          margin: 0;
          font-size: 16px;
        }
        .close-btn {
          background: none;
          border: none;
          color: white;
          cursor: pointer;
        }
        .modal-body {
          padding: 15px;
        }
        .quick-msg {
          display: block;
          width: 100%;
          padding: 10px;
          margin-bottom: 10px;
          background: #f8f9fa;
          border: 1px solid #dee2e6;
          border-radius: 5px;
          text-align: left;
          cursor: pointer;
          transition: all 0.3s;
        }
        .quick-msg:hover {
          background: #25D366;
          color: white;
          border-color: #25D366;
        }
        @media (max-width: 768px) {
          .whatsapp-button {
            bottom: 20px;
            right: 20px;
          }
          .whatsapp-modal {
            right: 20px;
            width: calc(100vw - 40px);
          }
        }
      `}</style>
    </>
  );
};

export default WhatsAppButton;